import { getTrainingProduct } from './trainingCourses'
import { Worker } from '../services/mockData'
import {
  BillingStep,
  Practice,
  PracticeAttendee,
  PracticeDraft,
} from '../types/practice'

export function requesterName(p: PracticeDraft): string {
  if (p.clientType === 'individuo')
    return `${p.firstName || ''} ${p.lastName || ''}`.trim() || '-'
  if (p.clientType === 'occasionale') return p.businessName || '-'
  return p.companyName || '-'
}

export function requesterKindLabel(p: PracticeDraft): string {
  if (p.clientType === 'individuo') return 'Individuo'
  if (p.clientType === 'occasionale') return 'Azienda cliente occasionale'
  return 'Azienda in anagrafica'
}

export function requestedCourseLabel(p: PracticeDraft): string {
  const product = getTrainingProduct(p.productCode)
  return product ? product.name : p.productCode || '-'
}

// Importo complessivo senza IVA:
// oraria = tariffa oraria × monte ore; singola = costo iscrizione × n° corsisti
export function practiceTotal(p: PracticeDraft): number | undefined {
  if (p.rateType === 'singola') {
    if (p.singleFee === undefined || !p.participantsCount) return undefined
    return p.singleFee * p.participantsCount
  }
  if (p.hourlyRate === undefined || !p.courseHours) return undefined
  return p.hourlyRate * p.courseHours
}

// N° partecipanti: the people chosen for the course, or the declared number
export function attendeeCount(p: PracticeDraft): number | undefined {
  if (p.attendees && p.attendees.length > 0) return p.attendees.length
  return p.participantsCount
}

export function workerToAttendee(w: Worker): PracticeAttendee {
  const [firstName, ...rest] = w.name.split(' ')
  return {
    id: `att-w${w.id}`,
    firstName,
    lastName: rest.join(' '),
    email: w.email,
    workerId: w.id,
  }
}

export function rateTypeLabel(p: PracticeDraft): string {
  return p.rateType === 'singola' ? 'Tariffa singola' : 'Tariffa oraria'
}

export function isInPresence(p: PracticeDraft): boolean {
  return p.deliveryMode === 'aziendale' || p.deliveryMode === 'multiaziendale'
}

export function emptyPracticeDraft(): PracticeDraft {
  return {
    clientType: 'anagrafica',
    category: '',
    productCode: '',
    rateType: 'oraria',
    attendees: [],
    date: new Date().toISOString().slice(0, 10),
    status: 'In valutazione',
    history: [],
    participants: [],
    schedulingConfirmed: false,
    proforma: 'off',
    invoice: 'off',
    certificates: 'Da inviare',
  }
}

// Copies requester and course information into a new practice
export function duplicatePractice(p: Practice): PracticeDraft {
  return {
    ...emptyPracticeDraft(),
    clientType: p.clientType,
    companyName: p.companyName,
    firstName: p.firstName,
    lastName: p.lastName,
    businessName: p.businessName,
    clientEmail: p.clientEmail,
    attendees: p.attendees ? [...p.attendees] : [],
    category: p.category,
    productCode: p.productCode,
    rateType: p.rateType,
    hourlyRate: p.hourlyRate,
    courseHours: p.courseHours,
    singleFee: p.singleFee,
    participantsCount: p.participantsCount,
    source: p.source,
  }
}

export function billingStepLabel(step: BillingStep, doneLabel: string): string {
  if (step === 'fatto') return doneLabel
  if (step === 'da_fare') return 'Da fare'
  return 'Non richiesta'
}

export function formatDateTime(iso: string): string {
  const d = new Date(iso)
  return `${d.toLocaleDateString('it-IT')} alle ${d.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })}`
}

export function newId(prefix: string): string {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`
}
